<template>

  <div>
  <el-tabs type="border-card" v-model="activeName">
<!--    <el-tab-pane :label="$t('makeSchedule.visualization')" name="visualization">-->
<!--      <MfgVisualization v-if="this.activeName === 'visualization'"></MfgVisualization>-->
<!--    </el-tab-pane>-->
    <el-tab-pane :label="$t('makeSchedule.wujianPlan')" name="wujianPlan">
      <MfgWuJianPlan v-if="this.activeName === 'wujianPlan'"></MfgWuJianPlan>
    </el-tab-pane>
    <el-tab-pane :label="$t('makeSchedule.planAchievement')" name="planAchievement">
      <MfgPlanAchievements v-if="this.activeName === 'planAchievement'"></MfgPlanAchievements>
    </el-tab-pane>
<!--    <el-tab-pane :label="$t('makeSchedule.processProduce')" name="processProduce">-->
<!--      <MfgProcessProduce v-if="this.activeName === 'processProduce'" ></MfgProcessProduce>-->
<!--    </el-tab-pane>-->
<!--    <el-tab-pane label="切断加工生产性" name="jiaGongProductive">-->
<!--      <MfgJiaGongProductive v-if="this.activeName === 'jiaGongProductive'"></MfgJiaGongProductive>-->
<!--    </el-tab-pane>-->
<!--    <el-tab-pane :label="$t('makeSchedule.processCalendar')" name="processCalendar">-->
<!--      <ProcessCalendar v-if="this.activeName === 'processCalendar'" ></ProcessCalendar>-->
<!--    </el-tab-pane>-->
    <el-tab-pane :label="$t('makeSchedule.tuZhuangProduce')" name="tuZhuangProduce">
      <MfgTuZhuangProduce v-if="this.activeName === 'tuZhuangProduce'"></MfgTuZhuangProduce>
    </el-tab-pane>
    <el-tab-pane :label="$t('makeSchedule.paintingCalendar')" name="paintingCalendar">
      <PaintingCalendar v-if="this.activeName === 'paintingCalendar'" ></PaintingCalendar>
    </el-tab-pane>
    <el-tab-pane :label="$t('makeSchedule.zuLiProduce')" name="zuLiProduce">
      <MfgZuLiProduceActual v-if="this.activeName === 'zuLiProduce'"></MfgZuLiProduceActual>
    </el-tab-pane>
<!--    <el-tab-pane label="组立生产性" name="zuLiProductive">-->
<!--      <MfgZuLiProductive v-if="this.activeName === 'zuLiProductive'"></MfgZuLiProductive>-->
<!--    </el-tab-pane>-->
    <el-tab-pane :label="$t('makeSchedule.assemblyCalendar')" name="assemblyCalendar">
      <AssemblyCalendar v-if="this.activeName === 'assemblyCalendar'"></AssemblyCalendar>
    </el-tab-pane>
<!--    <el-tab-pane :label="$t('makeSchedule.shipmentSchedule')" name="shipmentSchedule">-->
<!--      <MfgShipmentScheduleArea v-if="this.activeName === 'shipmentSchedule'"></MfgShipmentScheduleArea>-->
<!--    </el-tab-pane>-->
<!--    <el-tab-pane :label="$t('makeSchedule.assemblyEach')" name="assemblyEach">-->
<!--      <MfgAssemblyEachUnitNum v-if="this.activeName === 'assemblyEach'"></MfgAssemblyEachUnitNum>-->
<!--    </el-tab-pane>-->
<!--    <el-tab-pane :label="$t('makeSchedule.assemblyProcessShipmentArea')" name="assemblyProcessShipmentArea">-->
<!--      <MfgAssemblyProcessShipmentArea v-if="this.activeName === 'assemblyProcessShipmentArea'"></MfgAssemblyProcessShipmentArea>-->
<!--    </el-tab-pane>-->
<!--    <el-tab-pane :label="$t('makeSchedule.assemblyProcessShipmentWeight')" name="assemblyProcessShipmentWeight">-->
<!--      <MfgAssemblyProcessShipmentWeight v-if="this.activeName === 'assemblyProcessShipmentWeight'"></MfgAssemblyProcessShipmentWeight>-->
<!--    </el-tab-pane>-->
<!--    <el-tab-pane :label="$t('makeSchedule.finishedProductStorage')" name="finishedProductStorage">-->
<!--      <MfgFinishedProductStorage v-if="this.activeName === 'finishedProductStorage'"></MfgFinishedProductStorage>-->
<!--    </el-tab-pane>-->
  </el-tabs>
  </div>
</template>

<script>
import MfgPlanAchievements from "@/views/applications/bus/make_schedule/MfgPlanAchievements";
// import MfgZuLiProductive from "@/views/applications/bus/make_schedule/MfgZuLiProductive";
import MfgVisualization from "@/views/applications/bus/make_schedule/MfgVisualization";
import AssemblyCalendar from "@/views/applications/bus/make_schedule/AssemblyCalendar";
import PaintingCalendar from "@/views/applications/bus/make_schedule/PaintingCalendar";
import ProcessCalendar from "@/views/applications/bus/make_schedule/ProcessCalendar";
//import MfgJiaGongProductive from "@/views/applications/bus/make_schedule/MfgJiaGongProductive";
import MfgWuJianPlan from "@/views/applications/bus/make_schedule/MfgWuJianPlan";
import MfgZuLiProduceActual from "@/views/applications/bus/make_schedule/MfgZuLiProduceActual";
import MfgProcessProduce from "@/views/applications/bus/make_schedule/MfgProcessProduce";
import MfgShipmentScheduleArea from "@/views/applications/bus/make_schedule/MfgShipmentScheduleArea";
import MfgAssemblyEachUnitNum from "@/views/applications/bus/make_schedule/MfgAssemblyEachUnitNum";
import MfgAssemblyProcessShipmentArea from "@/views/applications/bus/make_schedule/MfgAssemblyProcessShipmentArea";
import MfgAssemblyProcessShipmentWeight from "@/views/applications/bus/make_schedule/MfgAssemblyProcessShipmentWeight";
import MfgTuZhuangProduce from "@/views/applications/bus/make_schedule/MfgTuZhuangProduce";
import MfgFinishedProductStorage from "@/views/applications/bus/make_schedule/MfgFinishedProductStorage";
export default {
  name: "MakeHomePage",
  components:{
    MfgFinishedProductStorage,
    MfgAssemblyProcessShipmentWeight,
    MfgAssemblyProcessShipmentArea,
    MfgAssemblyEachUnitNum,
    MfgShipmentScheduleArea,
    MfgTuZhuangProduce,
    MfgProcessProduce,
    MfgZuLiProduceActual,
    MfgWuJianPlan,
    // MfgJiaGongProductive,
    ProcessCalendar,
    PaintingCalendar,
    AssemblyCalendar,
    MfgVisualization,
    // MfgZuLiProductive,
    MfgPlanAchievements
  },
  data(){
    return{
      activeName: 'visualization'
    }
  },
  methods: {},
  created() {
  }
}
</script>

<style scoped>

</style>